import { WorkspaceApiKey } from '#packages/apis';
import { SpotlightStageScroll } from './components/SpotlightStageScroll';

import type { Shell } from '#packages/apilib';

export const bootstrapSpotlightStage = (shell: Shell) => {
  const workspaceAPI = shell.getAPI(WorkspaceApiKey);
  workspaceAPI.contributeStageComponent(SpotlightStageScroll);
};
